import { Dispatch } from "redux";
import { PaymentActionTypes, PolicyActionTypes } from "./types";
import { IPaymentResponse } from "../../models/payment-response.interface";
import { paymentService } from "../../services/payment.service";
import { PolicyAction } from "./policy.actions";

export interface PaymentAction {
  type: PaymentActionTypes;
  payload: IPaymentResponse | null;
}

export const paymentActions = {
  clearPaymentResponse: () => {
    return async (dispatch: Dispatch) => {
      dispatch<PaymentAction>({
        type: PaymentActionTypes.CLEAR_PAYMENT_RESPONSE,
        payload: null
      });
      dispatch<PolicyAction>({
        type: PolicyActionTypes.CLEAR_POLICY_RESPONSE,
        payload: null
      });
    }
  },
  initiatePayment: (policyId: number) => {
    return async (dispatch: Dispatch) => {
      dispatch<PaymentAction>({
        type: PaymentActionTypes.INITIATE_PAYMENT,
        payload: null
      });

      
      await paymentService.initiatePayment(policyId).then(response => {
        dispatch<PaymentAction>({
          type: PaymentActionTypes.PAYMENT_PROCESS_STARTED,
          payload: response.data
        });
      }, error => {
        //console.log(error);
        dispatch<PaymentAction>({
          type: PaymentActionTypes.PAYMENT_PROCESS_FAILED,
          payload: null
        });
      });
    };
  }
};
